import red from "@material-ui/core/colors/red";
import { createTheme } from "@mui/material";

// theme mui v5
const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#fcb71e",
      contrastText: "#ffffff",
    },
    secondary: red,
  },
  typography: {
    fontSize: 14,
    fontFamily: "inherit",
    "@media (max-width:900px)": {
      fontSize: 12,
    },
    color: "#263238",
  },
  components: {
    MuiTextField: {
      defaultProps: {
        autoComplete: "off",
        fullWidth: true,
        spellCheck: false,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#b08015",
          },
        },
      },
    },
  },
});

export default muiTheme;
